<template>
  <div style="padding:10px">
    <div class="row">
       <div class="col-md-10">

       </div>
       <div class="col-md-2">

       </div>
    </div>
    <div class="col-md-12">
        <h4>Manifestações em Espera</h4>
    </div>
    <div class="col-md-12" v-if="result_detalhes">
      <div class="card" style="margin-top:20px;background-color: #50bb4e !important;color: #fff !important;" >
        <div class="card-body">
          <div class="row">
            <div class="col-md-4" >
              Manifestação Cadastrado com Sucesso!
              <br>
              Numero da Manifestação: {{result_detalhes.uuid}}</div>
          </div>
          
        </div>  
      </div> 
    </div>
    <div class="col-md-12" v-if="exibir">
      <div class="row" id="exib-manif">
        <div class="col-md-4" ><h5>Número da Manifestação: <span class="badge badge-secondary" style="font-size: 14px;">{{exibir.uuid}}</span></h5></div>
        <div class="col-md-2" ><h5>Tipo: <span class="badge badge-secondary" style="font-size: 14px;">{{exibir.tipo_assunto}}</span></h5></div>
        <div class="col-md-4"><h5> Unidade Organizacional: {{exibir.secretaria}}</h5></div>

        <div class="col-md-12" style="font-weight:700;" v-if="exibir.bairro"> Local ocorrência</div>
        <div class="col-md-12" v-if="exibir.bairro"><h5> Bairro: {{exibir.bairro}}</h5></div>
        <div class="col-md-12" v-if="exibir.rua"><h5> {{exibir.rua}}, {{exibir.numero}} - {{exibir.complemento}}</h5></div> 
      </div>
      <div class="card" style="margin-top:20px;" >
        <div class="card-body">
          
          <div class="row">
            
            <div class="col-md-12"> Assunto: {{exibir.assunto}}</div>
            <div class="col-md-12" style="margin-bottom: 20px;margin-top:10px">Descrição: {{exibir.conteudo}}</div>
          </div>
        </div>  
      </div> 
    </div> 
    <div class="col-md-12" >
      <vue-good-table 
        :columns="columns"
        :rows="manifestacao_exibir"
        :lineNumbers="false"
        :search-options="{
          enabled: true,
          placeholder: 'Pesquisar',
        }"
        :pagination-options="{
              enabled: true,
              mode: 'records',
              mode: 'pages',
              perPage: 5,
              position: 'bottom',
              perPageDropdown: [5, 10, 15],
              dropdownAllowAll: false,
              nextLabel: 'Próximo',
              prevLabel: 'Anterior',
              rowsPerPageLabel: 'Linhas por página',
              ofLabel: 'de',
              pageLabel: 'pagina', 
              allLabel: 'All',
        }"
        >
          <template slot="table-row" slot-scope="props">
              <div v-if="props.column.field == 'action'">
                  <button class="btn btn-success" @click="detalhes(props.row)" style="margin-right:5px;border-color: #009688;color: #009688;">
                    <i class="fa fa-eye"></i>
                  </button>
                  <button class="btn btn-primary" @click="conversar(props.row)" style="margin-right:5px;">
                    <i class="fa fa-pencil-square-o"></i>
                  </button>
              </div>
              <span v-else>
                   {{props.formattedRow[props.column.field]}}
              </span>
          </template>
      </vue-good-table> 
    </div>  
    
  </div>
  
</template>



<script>

import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table';
import axios from 'axios';
import store_cidadao from "src/storeCidadao.js"
import 'src/controller/sistema/manifestacaoController.js'
import 'src/controller/cidadao/cidadaoController.js'
import 'src/controller/sistema/assuntoSecretariaController.js'
import 'src/controller/sistema/usuarioController.js'

export default {
  name: 'my-component',
  components: {
    VueGoodTable,
  },
  props: {
    row:null
    /*id: {
      require: true
    } */ 
  },
  data(){
    return {
      columns: [
        {
          label: 'Tipo',
          field: 'tipo_assunto',
        },
        {
          label: 'Assunto',
          field: 'assunto',
          sortable: false,
        },
        {
          label: 'Número da Manifestação',
          field: 'numero_manifesto',
          sortable: false,
        },
        {
          label: 'Unidade Organizacional',
          field: 'secretaria',
        },
        {
          label: 'Habilitar',
          field: 'abertura',
          hidden: true,
        },
        {
          label: 'Ações',
          field: 'action',
          sortable: false,
        },
        {
          label: 'id',
          field: 'uuid',
          hidden: true,
        }
        
      ],
      manifestacao:[],
      manifestacao_exibir:[],
      result_detalhes:null,
      exibir:null,
      me2:null,

    };
  },
   methods: {
      conversar(row){
        let result_detalhes = row;
        this.$router.push({name: 'conversasCid',params:{result_detalhes: result_detalhes} } );
      },
      async listarTudo(){
        try {
            
           
            let data = await this.$listarManifestosCidadao(store_cidadao.id_cidadao);
            this.manifestacao = data.data;
            
            //console.log(data);

            let a = [];
            let assuntos = a.data;

            let s = await this.$secretaria();
            let secretarias = s.data;

            this.manifestacao.forEach(array => {
                this.filtro(array,assuntos,secretarias);
            });
        } catch (e) {
              
        }
      },
      async filtro(array,assuntos,secretarias) {
         try {
            
              let assunto;
              let secretaria;
              
              secretarias.forEach(element => {
                if(array.secretaria == element.id){
                    secretaria = element.secretaria;
                }
              });

              
              if(array.abertura == "Espera"){
                  let manifesto={
                      uuid: array.uuid,
                      numero_manifesto: array.uuid,
                      tipo_assunto: array.tipo_assunto,
                      assunto: array.assunto,
                      secretaria: secretaria,
                      abertura: array.abertura,
                      conteudo: array.conteudo,
                      cidadao_login: array.cidadao_login,
                  };
                this.manifestacao_exibir.push(manifesto);
              }
         } catch (error) {
           //console.log(error);
         }
      },
      detalhes(row){
        //console.log(row);
          this.exibir=row;
      },
      async meuLogin2(){
        this.me2 = store_cidadao.id_cidadao;
      }
      
   }, 
  beforeMount() {
    try {
      this.meuLogin2();
      this.listarTudo();
      if(row !=null){
         this.result_detalhes = this.row;
      }
      
    }catch(e){
      
    }
    
  }
};
</script>
<style>
#exib-manif div h5{
  margin-bottom: 0px;
  color: #96989a;
}
</style>

